import { format } from "date-fns";
import api from "./api";
export const getAllEmployesBasedOnStateDistrict = async (state, district) => {
  // Build the base URL
  let url = `/api/employee-posting/filter-based-state?stateId=${state}`;

  // Add districtId to the URL if district is provided
  if (district) {
    url += `&districtId=${district}`;
  }

  // Make the API request
  const response = await api.get(url);
  return response.data;
};


export const sendResignationMail = async (empId, formDataToSend) => {
  try {
    const response = await api.post(`/api/resignations/${empId}`, formDataToSend, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to send resignation mail:', error.response?.data || error.message);
    throw error; // Let caller handle alert
  }
};
export const resginationCheckEmployePersonal = async (empId) => {
  try {
    const response = await api.get(`api/resignations/employee/${empId}`);
    return response; // Return full response instead of response.data
  } catch (error) {
    console.log("Error ", error);
    throw error; // Throw error to be caught in component
  }
}


export const employeeResignsList = async (state, district,) => {


  try {
    let url = `api/resignations/district-resignations?stateId=${state}`;

    // Add districtId to the URL if district is provided
    if (district) {
      url += `&districtId=${district}`;
    }

    // Make the API request
    const response = await api.get(url);
    return response.data;


  } catch (error) {
    console.log("error", error)
  }

}

export const resignEmployeeListFromZoneId = async (zoneId) => {

  try {
    const response = await api.get(`/api/resignations/zone/${zoneId} `)
    return response.data;
  } catch (error) {
    console.log("error fetching resign EMployee", error);
  }

}

export const releveEmployee = async (selectedEmp, payload) => {
  try {
    const response = await api.put(`api/resignations/${selectedEmp}/relieve`, payload);
    return response.data;

  } catch (error) {
    console.log("ErrorReleving", error);
  }
}


export const terminationRequest = async (payload) => {
    try {
        const response = await api.post(`api/termination/request`, payload);
        return response.data;
    } catch (error) {
        console.log("Error in terminationRequest:", error);
        throw error; // IMPORTANT: Re-throw the error so it can be caught in handleSave
    }
}

export const getPendingTerminations = async () => {
    try {
        const response = await api.get('/api/termination/pm/pending');
        return response.data;
    } catch (error) {
        console.error("Error fetching pending terminations:", error);
        throw error;
    }
};

// Approve/Reject termination request
export const approveTerminationRequest = async (requestId, payload) => {
    try {
        const response = await api.post(`/api/termination/approve/pm/${requestId}`, payload);
        return response.data;
    } catch (error) {
        console.error("Error approving/rejecting termination:", error);
        throw error;
    }
};
export const getPendingTerminationsHR = async () => {
    const res = await api.get(`/api/termination/hr/pending`);
    return res.data;
};

// POST Approve / Reject
export const approveTerminationHR = async (id, payload) => {
    const res = await api.post(`/api/termination/approve/hr/${id}`,payload);
    return res.data;
};